import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Import the locale
import { Typography, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { esES } from '@mui/x-date-pickers/locales'; // MUI locale for UI labels
import { Question, Questionnaire } from './models';
import RequiredAsterisk from './RequiredAsterisk';


const InputDateView = ({ question, questionnaire, onChange }: { question: Question, questionnaire: Questionnaire, onChange: (question: Question) => void }) => {
  const { i18n, t } = useTranslation(questionnaire.cohort);
  const handleOnChange = (value: dayjs.Dayjs | null) => {
    question.value = value ? dayjs(value).format('YYYY-MM-DD') : '';
    onChange(question);
  };

  const labelId = `question-${question.key}-label`;

  return (
    <div>
      <Typography id={labelId} variant="h6" component='div'>
        {t(question.question)}
          {question.required && <RequiredAsterisk />}
      </Typography>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={i18n.language === 'es-419' ? 'es-419' : 'en'}
        localeText={i18n.language === 'es-419' ? esES.components.MuiLocalizationProvider.defaultProps.localeText : undefined}
      >
        <DatePicker
          defaultValue={dayjs()}
          value={typeof question.value === 'string' && question.value ? dayjs(question.value) : null}
          onChange={handleOnChange}
          slotProps={{
            textField: {
              inputProps: {
                'aria-labelledby': labelId,
              },
              placeholder: t(question.placeholder || 'Pick a date'),
              fullWidth: true,
            } as React.ComponentProps<typeof TextField>,
          }}
        />
      </LocalizationProvider>
    </div>
  );
}

export default InputDateView;
